enum ProjectStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  FINISHED = 'FINISHED',
  DELETED = 'DELETED',
  TRIAL = 'TRIAL',
  NONE_SELECTED = 'NONE_SELECTED',
}

export default ProjectStatus